/**
 * web.service.ts
 * Copyright (c) 2016 Taillight LLC
 */

import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthenticationModel } from '../../models/user.auth';
import { RESTServiceClient } from '../../services/utilities/rest.client';
import { Config } from '../config';
import { map } from 'rxjs/operators';

@Injectable()
export class TemporaryTokenService {
    constructor(
        private restClientSvc: RESTServiceClient,
        private config: Config
    ) {
    }
    getTemporaryToken(): Observable<string> {
        return this.restClientSvc.get<AuthenticationModel>(
            `${this.config.get('commerceApiUrl')}/enchelper/imtoken`,
            new HttpHeaders({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': ''
            })
        )
            .pipe(
                map(
                    (resp) => resp.TokenValue
                )
            );
    }
}
